export default Object.freeze({
    DecimalFormat: 0,
    MinuteFormat: 1,
});
